(function () {
	const scrollShowcase = () => {
		const box = document.querySelector(".scroll-showcase-box");
		const items = document.querySelectorAll(".scroll-showcase_item");
		if (!box || !items.length) return;

		const setActiveImage = (activeIndex, opacity, scale) => {
			items.forEach((item, i) => {
				if (i < activeIndex) {
					item.style.opacity = 1;
					item.style.transform = "scale(1)";
				} else if (i === activeIndex) {
					item.style.opacity = opacity;
					item.style.transform = `scale(${scale})`;
				} else {
					item.style.opacity = 0;
					item.style.transform = "scale(0.8)";
				}
			});
		};

		const updateFromScrollPosition = () => {
			const rect = box.getBoundingClientRect();
			const windowHeight = window.innerHeight;
			const scrollableDistance = box.offsetHeight - windowHeight;

			if (scrollableDistance <= 0) return;

			const scrolledPast = -rect.top;
			let progress = scrolledPast / scrollableDistance;
			progress = Math.max(0, Math.min(1, progress));

			const rawIndex = progress * items.length;
			let activeIndex = Math.floor(rawIndex);
			if (activeIndex >= items.length) activeIndex = items.length - 1;

			const withinItemProgress = rawIndex - activeIndex;
			const opacity = withinItemProgress;
			const scale = 0.8 + withinItemProgress * 0.2;

			setActiveImage(activeIndex, opacity, scale);
		};

		window.addEventListener("scroll", updateFromScrollPosition, { passive: true });
		window.addEventListener("resize", updateFromScrollPosition);
		updateFromScrollPosition();
	};

	document.addEventListener("DOMContentLoaded", scrollShowcase);
})();